import EstadoDeudaDelete from './EstadoDeudaDelete'
export {EstadoDeudaDelete}
export default EstadoDeudaDelete
